import { InputClassKey } from '@material-ui/core/Input';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const THDInputStyles: Partial<Record<InputClassKey, CSSProperties>> = {
  root: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '125%',
    boxSizing: 'border-box',
    backgroundColor: 'white',
    border: '1px solid #7A7978',
    borderRadius: '2px',
    height: '44px',
    minWidth: '30px',
    padding: '10px 12px',
    '&$focused': {
      border: '1px solid #121111',
    },
    '&$disabled': {
      color: '#ccc',
      backgroundColor: '#eee',
      border: '#eee',
    },
    '&$error': {
      border: '1px solid #AB0000',
    },
  },
  formControl: {
    'label + &': {
      marginTop: '5px',
    },
  },
};
